import { render, staticRenderFns } from "./1login.vue?vue&type=template&id=5ed12104&scoped=true&"
import script from "./1login.vue?vue&type=script&lang=js&"
export * from "./1login.vue?vue&type=script&lang=js&"
import style0 from "./1login.vue?vue&type=style&index=0&id=5ed12104&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed12104",
  null
  
)

export default component.exports